import React from 'react';
import { Textarea } from '@chakra-ui/react';

import './style.scss';

interface Props {
	value: string;
	onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
	placeholder: string;
}

export const PlainTextEditor: React.FC<Props> = ({ value, onChange, placeholder }) => (
	<Textarea value={value} onChange={onChange} placeholder={placeholder} className='ee-html-editor' rows={10} />
);
